<section class="promo-banner">
    <div class="container">
        <h2>
            {{ 'banner.title' | translate }} 
        </h2>
        <div *ngIf="false">
            <a href="https://shop.twogetherflower.hu" target="_blank" rel="noopener" class="action-button">{{ 'banner.action' | translate }}</a>
        </div>
    </div>
</section>
